import { useIntl } from 'react-intl';

export const DEVIATED_LINE_ITEMS_COLUMN_VISIBILITY_KEY = 'deviatedLineItemsList';

// Assumed (ticket does not define it): every column except pacing, name and actions can be hidden.
export const DEVIATED_LINE_ITEMS_HIDEABLE_COLUMN_IDS = [
  'opRisk',
  'mediaChannel',
  'pricingModel',
  'account',
  'trader',
  'status',
  'endDate',
  'deviationValue',
  'totalSpend',
  'grossMargin',
  'impressions',
  'clicks',
  'videoComplete',
  'audioComplete',
  'visit',
  'footfall',
  'lastUpdate',
  'bidderRetries'
];

/** Labels of the hideable columns plus the name entry shown (always checked) in the column visibility menu. */
export function useDeviatedLineItemsColumnLabels(): Record<string, string> {
  const { formatMessage } = useIntl();

  return {
    account: formatMessage({ defaultMessage: 'Seat', id: 'deviatedLineItems.list.toolbar.seat' }),
    audioComplete: formatMessage({ defaultMessage: 'Audio C.', id: 'deviatedLineItems.list.toolbar.audioComplete' }),
    bidderRetries: formatMessage({
      defaultMessage: 'Sync Retries',
      id: 'deviatedLineItems.list.toolbar.bidderRetries'
    }),
    clicks: formatMessage({ defaultMessage: 'Clicks', id: 'deviatedLineItems.list.toolbar.clicksCtr' }),
    deviationValue: formatMessage({
      defaultMessage: 'Deviation value',
      id: 'deviatedLineItems.list.toolbar.deviationValue'
    }),
    endDate: formatMessage({ defaultMessage: 'Days Left', id: 'deviatedLineItems.list.toolbar.daysLeft' }),
    footfall: formatMessage({ defaultMessage: 'Store Visits', id: 'deviatedLineItems.list.toolbar.storeVisit' }),
    grossMargin: formatMessage({ defaultMessage: 'Gross Margin', id: 'deviatedLineItems.list.toolbar.grossMargin' }),
    impressions: formatMessage({ defaultMessage: 'Impressions', id: 'deviatedLineItems.list.toolbar.impressions' }),
    lastUpdate: formatMessage({ defaultMessage: 'L. Update', id: 'lineItems.list.toolbar.date' }),
    mediaChannel: formatMessage({ defaultMessage: 'Channel', id: 'deviatedLineItems.list.toolbar.channel' }),
    name: formatMessage({ defaultMessage: 'Line Item name', id: 'lineItems.list.columnVisibility.name' }),
    opRisk: formatMessage({ defaultMessage: 'Op. Risk', id: 'deviatedLineItems.list.toolbar.opRisk' }),
    pricingModel: formatMessage({ defaultMessage: 'P. Model', id: 'deviatedLineItems.list.toolbar.pricingModel' }),
    status: formatMessage({ defaultMessage: 'Status', id: 'lineItems.list.toolbar.status' }),
    totalSpend: formatMessage({ defaultMessage: 'Total Spend', id: 'deviatedLineItems.list.toolbar.totalSpend' }),
    trader: formatMessage({ defaultMessage: 'Trader', id: 'deviatedLineItems.list.toolbar.trader' }),
    videoComplete: formatMessage({ defaultMessage: 'Video C.', id: 'deviatedLineItems.list.toolbar.videoComplete' }),
    visit: formatMessage({ defaultMessage: 'Web Visits', id: 'deviatedLineItems.list.toolbar.webVisit' })
  };
}
